import React, { useState } from "react";
import { Share2, Facebook, Send, MessageCircle, Mail, Link as LinkIcon, Check } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ title = "TatiSiSofia.ro", url, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const text = encodeURIComponent(`${title} — ${shareUrl}`);

  const links = [
    { name: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${text}`, color: "#25D366" },
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, color: "#1877F2" },
    { name: "Telegram", icon: Send, href: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`, color: "#26A5E4" },
    { name: "Email", icon: Mail, href: `mailto:?subject=${encodeURIComponent(title)}&body=${text}`, color: "#A0AABF" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copiat");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Nu am putut copia link-ul");
    }
  };

  return (
    <div data-testid="share-buttons" className={`flex items-center gap-2 ${compact ? "" : "flex-wrap"}`}>
      {!compact && (
        <span className="text-xs text-[#A0AABF] uppercase tracking-widest mr-1 flex items-center gap-1.5">
          <Share2 className="w-3.5 h-3.5" /> Distribuie
        </span>
      )}
      {links.map(l => {
        const Icon = l.icon;
        return (
          <a
            key={l.name}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            data-testid={`share-${l.name.toLowerCase()}`}
            aria-label={`Share pe ${l.name}`}
            className="w-9 h-9 rounded-full grid place-items-center border border-white/10 bg-white/5 hover:bg-white/10 hover:border-[#D4A63D]/40 transition-all"
            style={{ color: l.color }}
          >
            <Icon className="w-4 h-4" />
          </a>
        );
      })}
      <button
        onClick={copy}
        data-testid="share-copy-link"
        className="w-9 h-9 rounded-full grid place-items-center border border-white/10 bg-white/5 hover:bg-white/10 hover:border-[#D4A63D]/40 text-[#F8F8F4] transition-all"
        aria-label="Copiază link"
      >
        {copied ? <Check className="w-4 h-4 text-[#3BA76D]" /> : <LinkIcon className="w-4 h-4" />}
      </button>
    </div>
  );
};
